<app-form-builder [fieldDetails]="widgetFields" (actionEvents)="actionHandler($event)" #createSingleMetricForm></app-form-builder>

